var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintReceipts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "118px",
    height: "128px",
    viewBox: "0 0 118 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1327695A-2204-4C95-8FFA-962559C3AC31@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Landing-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing-Page",
    transform: "translate(-661.000000, -738.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(502.000000, 699.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(160.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFD100",
    points: "58.2184113 9.30201342 17.1590542 26.3115083 0 67.2978592 16.4774152 109.027678 57.8856426 126 98.7786154 107.774403 115.932302 66.8039838 99.6427404 26.2743349"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy",
    stroke: "#C3D7EE",
    points: "58.2184113 0 17.1590542 17.0094949 0 57.9958458 16.4774152 99.7256651 57.8856426 116.697987 98.7786154 98.4723898 115.932302 57.5019704 99.6427404 16.9723215"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1607",
    transform: "translate(35.000000, 40.000000)",
    stroke: "#2774AE",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8713762,10.903261 L36.8713762,17 M10,17 L10,0 L10,0 L26.5203253,0",
    id: "path1381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.632526,11 L26.367474,11 C26.1638805,11 26,10.8361073 26,10.6325307 L26,0.367469298 C26,0.16389266 26.1638805,0 26.367474,0 L37,10.6325307 C37,10.8361073 36.8360931,11 36.632526,11 L36.632526,11 Z",
    id: "path1383",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,21 L42,21",
    id: "path1410",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path1402",
    strokeLinecap: "round",
    points: "8.85009766 34 0 34 0 17 46 17 46 34 37.2524414 34"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1597",
    transform: "translate(9.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.05395166,5.53424212 L21.9385591,5.53424212",
    id: "path1385",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.05395166,10.4695384 L21.9385591,10.4695384",
    id: "path1389",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect1393",
    x: 0.0262188967,
    y: 0.00601975705,
    width: 27.9400546,
    height: 15.9917348
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintReceipts);
export default __webpack_public_path__ + "static/media/PrintReceipts.4d4feca5c1dacfd29aa780b8fe69a336.svg";
export { ForwardRef as ReactComponent };